import _ from '@lodash';
import * as Actions from '../Actions/EmpresaPessoaExcecaoJornadaActions';

const initialState = {
    data: null,
    error: null,
    warning: null,
    info: null,
    template: null,
    id: null
};


const EmpresaPessoaExcecaoJornadaReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_EMPRESAPESSOAEXCECAOJORNADAS:
            {
                return {
                    ...state,
                    data: action.payload,
                };
            }
        case Actions.EMPRESAPESSOAEXCECAOJORNADA_INFO:
            {
                return {
                    ...state,
                    info: action.payload,
                    id: !_.isUndefined(action.id) ? action.id : null,
                };
            }
        case Actions.EMPRESAPESSOAEXCECAOJORNADA_WARNING:
            {
                return {
                    ...state,
                    warning: action.payload,
                };
            }
        case Actions.EMPRESAPESSOAEXCECAOJORNADA_ERROR:
            {
                return {
                    ...state,
                    error: action.payload,
                };
            }
        case Actions.GET_TEMPLATE:
            {
                return {
                    ...state,
                    template: action.payload,
                };
            }

        default:
            {
                return state;
            }
    }
};

const reducer = EmpresaPessoaExcecaoJornadaReducer
export default reducer;
